import BrandDefinition from '@/types/BrandDefinition';
import HeaderDictionary from '@/types/dictionaries/Header';
import Menu from '@mui/material/Menu';
import { SxProps, Theme } from '@mui/material/styles';
import { Session } from 'next-auth';
import BillingProfileMenuHeader from '@/components/Header/components/BillingProfileMenuHeader';
import AccountMenuList from '../../../AccountMenuList';
import AccountMenuDrawer from '../AccountMenuDrawer';

interface AccountMenuProps {
	anchorEl: null | HTMLElement;
	mobileMenuOpen: boolean;
	brand: BrandDefinition;
	sessionData: Session;
	dict: HeaderDictionary;
	showBillingProfileMenuHeader: boolean;
	handleClose: () => void;
	onOpenBillingProfileDialog: () => void;
	showInvoicesInAccountMenuList: boolean;
}

const menuStyle: SxProps<Theme> = {
	'& .MuiPaper-root': {
		minWidth: '244px',
		width: 'auto',
		marginTop: '40px',
	},
	'& .MuiList-root': {
		p: 0,
	},
	'& .MuiMenuItem-root': {
		borderBottom: '1px solid',
		borderColor: 'grey.light',
	},
	'& .MuiMenuItem-root:last-of-type': {
		borderBottom: 'none',
	},
};

export default function AccountMenu({
	anchorEl,
	mobileMenuOpen,
	brand,
	sessionData,
	dict,
	showBillingProfileMenuHeader,
	handleClose,
	onOpenBillingProfileDialog,
	showInvoicesInAccountMenuList,
}: Readonly<AccountMenuProps>) {
	return (
		<>
			<Menu
				data-testid="header-account-menu"
				anchorEl={anchorEl}
				open={!!anchorEl}
				onClose={handleClose}
				disableScrollLock
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				sx={menuStyle}
			>
				{showBillingProfileMenuHeader && (
					<BillingProfileMenuHeader
						dict={dict}
						accountMenuType="dropdown"
						onSwitchBillingProfile={onOpenBillingProfileDialog}
					/>
				)}
				<AccountMenuList dict={dict} showInvoices={showInvoicesInAccountMenuList} handleClose={handleClose} />
			</Menu>

			<AccountMenuDrawer
				open={mobileMenuOpen}
				onClose={handleClose}
				brand={brand}
				sessionData={sessionData}
				dict={dict}
				showBillingProfileMenuHeader={showBillingProfileMenuHeader}
				onSwitchBillingProfile={onOpenBillingProfileDialog}
				showInvoicesInAccountMenuList={showInvoicesInAccountMenuList}
			/>
		</>
	);
}
